(() => {
  if (customElements.get('facets-bar')) {
    return;
  }

  class FacetsBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('scroll', this.handleOnScroll.bind(this));

      this.handleOnScroll();
    }

    handleOnScroll() {
      const footer = document.querySelector('.footer');
      const footerThreshold = footer
        ? footer.offsetTop + footer.offsetHeight * 0.1
        : 0;

      const shouldShow = window.scrollY + window.innerHeight >= footerThreshold;

      this.classList.toggle('hidden', shouldShow);
    }
  }

  customElements.define('facets-bar', FacetsBar);
})();
